import React, {  useState , useEffect} from 'react';

import { useNotification } from 'config/Notification';

import { fetchAllStatus as fetchAllStatusService} from 'services/modules/cap/standardservice';

import '../styles/cap.css';

import CloseIcon from '@mui/icons-material/Close';

import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

const ReportStatusPage = ({toggleReportStatus}) => {

  // Notification
  const {openNotification} = useNotification();

  // State variables
  const [loading,setLoading]=useState(false);
  const [reportStatusList, setReportStatusList] = useState([]);
  const [show,setShow] = useState(true);
  
  useEffect(() => {
    getAllReportStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Method handles to fetch the status
  const getAllReportStatuses=async()=>{
    try {
      setLoading(true);
      setReportStatusList([]);
      let response = await fetchAllStatusService(); 
      if(response.data.length > 0){
        setReportStatusList(response.data);
      }
    }
    catch (error) {
      openNotification('Error while fetching Status','error');
    }
    finally{
      setLoading(false);
    }
  }; 
  
  return (
    <div>     
      <Dialog onClose={()=> setShow(false)} open={show}>
        <DialogTitle sx={{ m: 0, p: 2 }} >
          <h4 className='audit-trail-popuptext heading-popup'>Report Status Explained</h4>
        </DialogTitle>
        <IconButton onClick={()=> setShow(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {loading ? (
            <div className='txt-c p-10'>
              <CircularProgress />
            </div>
          ) : (
            <Typography gutterBottom>
              <div className='audit-trail-popuptext'>
                {reportStatusList.length>0 && reportStatusList.map((row) => (
                  <div key={row.id}>
                    <div  className="row">
                      <div className='col-1 d-flex'>
                        {(row.status === 'Open' ||
                          row.status === 'Work In Progress' ||
                          row.status === 'Review Assessment In Progress' ||
                          row.status === 'Mitigation Response In Progress' ||
                          row.status === 'Review Mitigation Response' ||
                          row.status === 'Mitigation In Progress') &&(
                            <img className='m-2' style={{ width: '20px' }} src='../assets/icons/002-comment-1.svg' draggable="false" alt=""/>
                        )}
                        {(row.status === 'Submitted' ||
                          row.status === 'Approved' ||
                          row.status === 'Cancelled' ||
                          row.status === 'Mitigation Initiated' ||
                          row.status === 'Mitigation Response Submitted' ||
                          row.status === 'Completed' ||
                          row.status === 'Reject Mitigation Response' ||
                          row.status === 'Reject Assessment') &&(
                            <img className='m-2' style={{ width: '20px' }} src='../assets/icons/001-comment.svg' draggable="false" alt="" />
                        )}
                      </div>
                      <div className="col-11">
                        <b className='header-color'>{row.status}</b>
                        <br />
                        <label>{row.description}</label>
                      </div>
                    </div>
                    <hr />
                  </div>
                ))}
              </div>
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default ReportStatusPage;
